import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { Helmet } from "react-helmet";
import "./App.css";
import { platformAdScript } from "./externalScript";
import "./plugins/i18n";
import { envChangeType } from "./plugins/utils";
import RouterRender from "./router/index";
import FontSetting from "./styles/FontSetting";

function App() {
  const defaultTheme = require(`./theme/defaultTheme.json`);
  const finalTheme = { ...defaultTheme };
  const [vh, setVh] = useState(1);

  const setTheme = () => {
    const r: any = document.querySelector(":root");
    const final = Object.entries(finalTheme);
    final.map((color) => {
      r?.style?.setProperty(color[0], color[1]);
    });
  };

  const initGTAG = () => {
    if (
      envChangeType("REACT_APP_GCODE") === "" ||
      envChangeType("REACT_APP_GCODE") === null ||
      envChangeType("REACT_APP_GCODE") === undefined
    )
      return;
    TagManager.initialize({
      gtmId: envChangeType("REACT_APP_GCODE"),
    });
  };

  const initStyle = () => {
    let _vh = window.innerHeight * 0.01;
    setVh(_vh);
    window.document.documentElement.style.setProperty("--vh", `${_vh}px`);
  };

  const renderScript = () => {
    if (process.env.REACT_APP_FB_PIXEL_ID) {
      const pixelArray = process.env.REACT_APP_FB_PIXEL_ID.split(",");
      return (
        <Helmet>
          <script type="text/javascript">
            {platformAdScript["FBpixel"].script({ id: pixelArray })}
          </script>
        </Helmet>
      );
    }
  };
  const renderNoScript = () => {
    if (process.env.REACT_APP_FB_PIXEL_ID) {
      const pixelArray = process.env.REACT_APP_FB_PIXEL_ID.split(",");
      return (
        <Helmet>
          <noscript>
            {platformAdScript["FBpixel"].noscript({ id: pixelArray })}
          </noscript>
        </Helmet>
      );
    }
  };

  // 監聽方向變化並調整畫面尺寸
  const handleOrientationChange = () => {
    // 延遲執行以確保方向變化完成
    setTimeout(() => {
      initStyle();
      // console.debug("Orientation changed, screen size adjusted");
    }, 100);
  };

  // 監聽視窗大小變化
  const handleResize = () => {
    initStyle();
    // console.debug("Window resized, screen size adjusted");
  };

  useEffect(() => {
    initStyle();
    initGTAG();
    setTheme();

    // 添加方向變化監聽器
    window.addEventListener("orientationchange", handleOrientationChange);

    // 添加視窗大小變化監聽器
    window.addEventListener("resize", handleResize);

    // 清理函數
    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /**
   * SCROLL TESTING PURPOSE
   * DO NOT DELETE, OPEN WHEN DEBUG SCROLL ISSUE ONLY
   */
  function isScrollable(el: any) {
    return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
  }
  window.addEventListener(
    "scroll",
    function (e: any) {
      var el: any = e.target;
      while (el && el !== document && !isScrollable(el)) {
        el = el?.parent;
      }
      console.debug("Scrolled element: " + (el?.className || "document"));
    },
    true
  );

  return (
    <div>
      {renderScript()}
      {renderNoScript()}
      <FontSetting />
      <RouterRender />
    </div>
  );
}

export default App;
